import { Component, OnInit } from '@angular/core';
import { Error } from 'src/app/shared/components/error/error.model';
import { MoreInfoService } from 'src/app/shared/services/more-info.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-error',
  templateUrl: './user-error.component.html',
  styleUrls: ['./user-error.component.scss']
})
export class UserErrorComponent implements OnInit {
  accountText: string = '';
  assetsUrl = environment.assetsUrl;
  needsToBeUpdated = 19;
  maxProductsCreated = 18;

  constructor(private moreInfoService: MoreInfoService) {}

  public config: Error = {
    route: `${this.assetsUrl}/images/cda/icons/close-icon.svg`,
    image: 'close-icon',
    title: 'Lo sentimos, no podemos continuar con tu solicitud',
    content: 'Debes acercarte a una oficina AV Villas para abrir tu CDT.'
  };

  ngOnInit(): void {
    this.config.content = this.changeContent();
    this.config.link = this.changeRedirect();
  }

  changeContent(): string {
    const { moreInfoData } = this.moreInfoService;
    const { generateOTPCode } = moreInfoData;

    switch (generateOTPCode) {
      case 19:
        return 'Te invitamos a que continúes la apertura de tu producto a través de los canales digitales AV Villas.';
      case 18:
        return 'Te invitamos a intentarlo más tarde.';
      default:
        return 'Debes acercarte a una oficina AV Villas para abrir tu CDT.';
    }
  }

  changeRedirect() {
    const { moreInfoData } = this.moreInfoService;
    const { generateOTPCode } = moreInfoData;

    switch (generateOTPCode) {
      case this.needsToBeUpdated:
        return {
          url: 'https://www.avvillas.com.co/bancadigital/inicio',
          text: 'Entendido'
        };
      case this.maxProductsCreated:
        return null;
      default:
        return this.createLinkObject();
    }
  }

  createLinkObject(): any {
    this.config = {
      ...this.config,
      link: {
        url: 'https://www.avvillas.com.co/BuscadordePuntosAvVillas/',
        text: '¿Dónde encontrarnos?'
      }
    };
  }
}
